import type { BusinessProfile, BusinessProfileBankDetails, UpdateBusinessProfileInput } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export interface BusinessProfileFormState extends BusinessProfileBankDetails {
  id?: GQL_ID
  owner_id: GQL_ID | null
  name: string
  address: string
  director: string
  phone_number?: string
  status: string
  require_invoice: boolean
  vat_enabled: boolean
}

export const BUSINESS_PROFILE_DEFAULT_STATE: BusinessProfileFormState = {
  id: undefined,
  owner_id: null,
  name: '',
  address: '',
  director: '',
  status: 'pending_check',
  phone_number: '',
  require_invoice: true,
  vat_enabled: true,
  bankName: '',
  bik: '',
  accountNumber: ''
}

export const makeBusinessProfileFormState = (
  businessProfile?: BusinessProfile
): BusinessProfileFormState => {
  return mergeLeft<BusinessProfileFormState>(BUSINESS_PROFILE_DEFAULT_STATE, businessProfile)
}

export const mapStateToApiVariable = (state: BusinessProfileFormState): UpdateBusinessProfileInput => ({
  status: state.status,
  phone_number: state.phone_number,
  name: state.name,
  address: state.address,
  require_invoice: state.require_invoice,
  vat_enabled: state.vat_enabled,
  director: state.director,
  bankDetails: {
    bankName: state.bankName,
    accountNumber: state.accountNumber,
    bik: state.bik
  },
  owner_id: state.owner_id
})

export const mapApiDataToState = (data: BusinessProfile): BusinessProfileFormState => ({
  id: data.id,
  name: data.name,
  status: data.status,
  phone_number: data.phone_number,
  director: data.director ?? '',
  owner_id: data.owner_id,
  address: data.address,
  require_invoice: data.require_invoice,
  vat_enabled: data.vat_enabled,
  ...data.bankDetails
})
